import 'bootstrap/dist/css/bootstrap.min.css';
import { useSelector } from 'react-redux';
import './App.css';
import ApplicationRoutes from './applicationRoutes';
import { getAuthInfo } from './state/checkoutSaga';

function App() {
  const loggedInUser = useSelector(getAuthInfo);
  const username = loggedInUser ? loggedInUser.authInfo?.username : "";

  return (
    <div className="App">
      <ApplicationRoutes />
      <div style={{ position: 'fixed', bottom: '16px', left: '16px', fontSize: '0.75rem', color: '#aaa', userSelect: 'none', pointerEvents: 'none' }}>
        1.8-{username}</div>
    </div>
  );
}

export default App;
